import script from "./BangKeChiTietXuatPrintTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./BangKeChiTietXuatPrintTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./BangKeChiTietXuatPrintTemplate.vue?vue&type=style&index=0&id=ad5cd454&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad5cd454"]])

export default __exports__